import styled from 'styled-components'
import { motion } from 'framer-motion'
import { Box, Typography } from 'src/components'

export const Description = styled(motion(Typography))`
    font-family: inherit;
    font-style: normal;
    line-height: 24px;
    text-align: center;
    margin-top: 10px;
    color: ${({ theme }) => theme.colors.white};
    width: 90%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 28px;
        width: 60%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 32px;
        width: 60%;
    }
`

export const OltServices = styled(motion(Box))`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 90%;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        display: flex;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1250px;
        flex-wrap: nowrap;
    }
`

export const ContentButton = styled(Box)`
    min-width: 88px;
    height: 40px;
`
